import { insertBoardObject } from './insertBoardObject'
import { mergeIncluded } from './mergeIncluded'
import { moveBoardObject } from './moveBoardObject'
import { removeBoardObject } from './removeBoardObject'
import { removeIncluded } from './removeIncluded'
import { setMomentRelationship } from './setMomentRelationship'
import { updateIncludedAttributes } from './updateIncludedAttributes'
import { upsertIncluded } from './upsertIncluded'

export type { BoardObjectsTransform } from './types'

export const boardObjectsCacheTransforms = {
  insertBoardObject,
  mergeIncluded,
  moveBoardObject,
  removeBoardObject,
  removeIncluded,
  setMomentRelationship,
  updateIncludedAttributes,
  upsertIncluded,
}
